import { render, staticRenderFns } from "./AgingConfig.vue?vue&type=template&id=79e97db6&"
import script from "./AgingConfig.vue?vue&type=script&lang=js&"
export * from "./AgingConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports